/**
 * Ajuda dos campos dos relatorios (P-BI-1).
 *
 * Juntada em `../ajudaDosCampos.ts`, que explica a chave e o texto. Ver
 * docs/FRONTEND.md, secao 6, e docs/ADR/0043-relatorios-bi.md.
 */
export const ajuda: Record<string, Record<string, string>> = {
  '/bi': {
    'Pesquisa de corretora':
      'Procura pelo nome ou pelo comeco do CNPJ. Com acesso restrito a uma corretora, so ela aparece, e o relatorio soma so o que e dela.',
    'Pesquisa de tomador':
      'Procura pelo nome ou pelo comeco do documento. Nome e CPF de pessoa fisica saem mascarados sem a permissao de dado pessoal.',
    'Pesquisa de grupo economico':
      'Procura pelo nome do grupo ou pelo CPF ou CNPJ de quem encabeca o grupo. Filtra os tomadores que participam dele.',
    'Distribuicao da carteira vigente':
      'Troca a metrica da matriz classe x porte e dos mapas. So tomadores com apolice tem definicao; as outras dependem de "vigente", que esta pendente.',
    // P-BI-2: o seletor "Valor Dinamico Esteira" da pagina Esteira.
    Metrica:
      'Troca a medida do resumo das esteiras e do grafico de conversao. Taxa de conversao e canceladas pelo job estao pendentes de definicao.',
  },
};
